function openAnchorAccordion() {
    if (window.location.hash) {
        var $hashTarget = $('body').find("[data-accordion-id='" + window.location.hash.substring(1) + "']");
        var accordion = $hashTarget.find(".accordion__header");
        if (accordion.length) {
            accordion
                .parent().toggleClass("active")
                .siblings().removeClass("active");

            // console.debug("scrolling to [data-accordion-id='" + window.location.hash.substring(1) + "'] at position " + accordion.offset().top);
            //$('html, body').animate({ scrollTop: accordion.offset().top }, 'fast');
            $('html, body').animate({ scrollTop: accordion.offset().top - accordion.height() }, 'fast');
        }
    }
}

function accordion() {
    var container = $(".accordion");
    var trigger = $(container).find(".accordion__header");
    var accordionsInUse = false;

    if ($(container).length > 0) {

        //uses jquery.collapsable.js for better accessibility 
        console.log("trigger",trigger.html());
        $(trigger).collapsible();

        fallbackHeaderValue();

        $(trigger).on("click", accordionClicked());

        //click outside accordion, then collapse
        $(document).on("click", documentClick());
    }

   

    function fallbackHeaderValue() {
        if (window.siteSettings.locale === 'da') {
            $(trigger).find(".collapsible-heading-status").each(function () {
                $(this).html("Vis ");
            });
        }
    }

    function documentClick() {
        return function (e) {
            var clickedOutsideAccordion = !$(e.target).closest(container).length && !$(e.target).is(container);
            var printClicked = $(e.target).is('.print');
            if (clickedOutsideAccordion && !printClicked) {
                $(trigger)
                    .parent().removeClass("active")
                    .siblings().removeClass("active");
            }
        };
    }

    function accordionClicked() {
        return function () {
            var $self = $(this);
            $self
                .parent().toggleClass("active")
                .siblings().removeClass("active");

            //assign hash id
            //var $hashTarget = $self.find(".numeric-badge");
            var accordionId = $self.parent().data("accordion-id");
            if (accordionId) {
                window.location.hash = accordionId;
            }

            //Scroll to the clicked accordion item
            if (accordionsInUse && $self.parents(".content__main").length > 0) {
                var containerOffset = $(container).offset().top;
                var headerHeight = $(".main-header").outerHeight(true);
                var selfClosedHeight = $self.find(".accordion__title").outerHeight(true);
                var scrollOffsetByIndex = selfClosedHeight * $self.parent().index();
                //Set the scroll distance we want to scroll
                var offsetBuffer = 100;
                var scrollDistance = containerOffset - headerHeight + scrollOffsetByIndex - offsetBuffer;
                if ($self.parent().hasClass("active")) {
                    $('html,body').animate({ scrollTop: scrollDistance }, 200);
                }
            }

            fallbackHeaderValue();

            //update header
            if (window.siteSettings.locale === 'da') {
                if ($self.parent().hasClass("active")) {
                    $(this).find(".collapsible-heading-status").html("Skjul ");
                }
                else {
                    $(this).find(".collapsible-heading-status").html("Vis ");
                }
            }

            //firefox-fix for iframes
            if ($self.parent().hasClass("active")) { //toggle accordion
                var iframes = $self.parent().find("iframe");
                if (iframes && iframes.length) {
                    $.each(iframes, function (i, iframe) {
                        var src = $(iframe).attr('src');
                        console.debug('reloaded iframe: ' + src);
                        $(iframe).attr('src', src); //reload iframe hack
                    });
                }
            }

            //minimaps in accordions hack
            if ($self.parent().hasClass("active")) { //toggle accordion
                var maps = $self.parent().find(".js-minimap");
                if (maps && maps.length) {
                    console.debug('minimap accordion fix');
                    // a resize event triggers minimap to update
                    var resizeEvent = window.document.createEvent('UIEvents');
                    resizeEvent.initUIEvent('resize', true, false, window, 0);
                    window.dispatchEvent(resizeEvent);
                }
            }

            //We detect the first click on a accordion item - so that we wait with the auto scrolling part.
            accordionsInUse = true;
        };
    }
}

$(function () {
    accordion();
    openAnchorAccordion();
});